import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  error: false,
  identidadError: false,
  complete: false,
  documentoConyuge: null,
  sexoConyuge: null,
  nombreConyuge: null,
  apellidoConyuge: null,
  fechaNacimiento: null,
  cuil: null,
  actividadDeclarada: null,
  rubroEmpleoPublico: null,
  antiguedad: null,
  ingresos: 0,
  identidadPersonas: null,
  personaSeleccionada: null,
  telefono: null,
};

const agregarConyugeCodeudorSlice = createSlice({
  name: "conyugeCodeudor",
  initialState,
  reducers: {
    conyugeCodeudorSetDni: (state, action) => {
      state.documentoConyuge = action.payload;
      state.complete = false;
    },
    conyugeCodeudorSetSexo: (state, action) => {
      state.sexoConyuge = action.payload;
      state.complete = false;
    },
    conyugeCodeudorFetchIdentidadInited: (state) => {
      state.isLoading = true;
      state.nombreConyuge = null;
      state.apellidoConyuge = null;
      state.fechaNacimiento = null;
      state.cuil = null;
      state.actividadDeclarada = null;
      state.rubroEmpleoPublico = null;
      state.antiguedad = null;
      state.ingresos = 0;
      state.complete = false;
      state.identidadPersonas = null;
      state.personaSeleccionada = null;
      state.telefono = null;
    },
    conyugeCodeudorFetchIdentidadCompleted: (state, action) => {
      const response = action.payload;
      const tieneMultiplesPersonas = response.personas?.length > 1;

      state.isLoading = false;
      state.identidadError = false;
      state.complete = false;
      state.identidadPersonas = response;

      if (!tieneMultiplesPersonas) {
        const persona = response.personas?.[0] || response;
        state.nombreConyuge = persona.nombres;
        state.apellidoConyuge = persona.apellido;
        state.fechaNacimiento = persona.fechaNacimiento;
        state.cuil = persona.cuil;
      }
    },
    conyugeCodeudorFetchIdentidadFailed: (state) => {
      state.isLoading = false;
      state.identidadError = true;
      state.complete = false;
    },
    conyugeCodeudorSetPersonaSeleccionada: (state, action) => {
      const persona = action.payload;
      state.personaSeleccionada = persona;
      state.nombreConyuge = persona.nombres;
      state.apellidoConyuge = persona.apellido;
      state.fechaNacimiento = persona.fechaNacimiento;
      state.cuil = persona.cuil;
      state.complete = false;
    },
    conyugeCodeudorSetActividad: (state, action) => {
      state.actividadDeclarada = action.payload;
      state.rubroEmpleoPublico = null;
      state.antiguedad = null;
      state.complete = false;
    },
    conyugeCodeudorSetRubro: (state, action) => {
      state.rubroEmpleoPublico = action.payload;
      state.antiguedad = null;
      state.complete = false;
    },
    conyugeCodeudorSetAntiguedad: (state, action) => {
      state.antiguedad = action.payload;
      state.complete = false;
    },
    conyugeCodeudorSetIngresos: (state, action) => {
      state.ingresos = action.payload;
      state.complete = false;
    },
    conyugeCodeudorSetComplete: (state, action) => {
      state.complete = action.payload;
    },
    conyugeCodeudorSetTelefono: (state, action) => {
      state.telefono = action.payload;
    },
    conyugeCodeudorClear: () => initialState,
  },
});

export const {
  conyugeCodeudorSetDni,
  conyugeCodeudorSetSexo,
  conyugeCodeudorFetchIdentidadInited,
  conyugeCodeudorFetchIdentidadCompleted,
  conyugeCodeudorFetchIdentidadFailed,
  conyugeCodeudorSetActividad,
  conyugeCodeudorSetRubro,
  conyugeCodeudorSetAntiguedad,
  conyugeCodeudorSetIngresos,
  conyugeCodeudorSetComplete,
  conyugeCodeudorClear,
  conyugeCodeudorSetPersonaSeleccionada,
  conyugeCodeudorSetTelefono,
} = agregarConyugeCodeudorSlice.actions;

export const fetchIdentidad = (dni, sexo) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(conyugeCodeudorFetchIdentidadInited());
      const response = await services.api.getIdentidad(dni, sexo);
      dispatch(conyugeCodeudorFetchIdentidadCompleted(response));
    } catch (error) {
      dispatch(conyugeCodeudorFetchIdentidadFailed(error));
    }
  };
};

export default agregarConyugeCodeudorSlice.reducer;
